import React, { useState } from "react";

// import GoogleMapsAutoCompPriceCal from "components/GoogleMapAutoCompPriceCal";
// import moduleStyle from "./../../src/assets/css/SearchBooking.module.css";
import "./SearchBooking.css";

import { FaPlusCircle } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";
import { RxCrossCircled } from "react-icons/rx";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { ImCross } from "react-icons/im";
import { IoIosArrowDown } from "react-icons/io";
import { HiPlusSm } from "react-icons/hi";
import { FaArrowRight } from "react-icons/fa";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getAllVehicles } from "../../redux/AdminReducer";

import { TbArrowsDownUp } from "react-icons/tb";
import { getPricing } from "../../redux/CustomerReducer";
import { useTranslation } from "react-i18next";
import GoogleMapAuto from "./GoogleMapAuto";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GoogleApiWrapper, Map, Marker } from "google-maps-react";
// import { google } from 'google-maps-react/google';
// import { set } from "immer/dist/internal";
// import { PlusOneOutlined } from "@material-ui/icons";
const google = window.google;

const SearchBooking = () => {
  const { t, i18n } = useTranslation();
  const pricingData = useSelector(
    (state) => state?.CustomerReducer?.getPricingData[0]?.pricing
  );
  const dispatch = useDispatch();

  const navigate = useNavigate();
  console.log("pricingData", pricingData);
  const addressData = [
    {
      description: "London Heathrow terminal 5 TW6 2GA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "London Heathrow terminal 4 TW6 3XA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "Hertford East Train Station Hertford SG14 1SB",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },

    {
      description: "London Heathrow terminal 5 TW6 2GA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "London Heathrow terminal 4 TW6 3XA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "Hertford East Train Station Hertford SG14 1SB",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },

    {
      description: "London Heathrow terminal 5 TW6 2GA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "London Heathrow terminal 4 TW6 3XA",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
    {
      description: "Hertford East Train Station Hertford SG14 1SB",
      matched_substrings: [{ length: 6, offset: 0 }],
      place_id: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      reference: "ChIJ2QeB5YMEGTkRYiR-zGy-OsI",
      structured_formatting: {
        main_text: "Lahore",
        main_text_matched_substrings: Array(1),
        secondary_text: "Pakistan",
      },
      terms: [{ offset: 0, value: "lahore" }],
      types: ["locality", "political", "geocode"],
    },
  ];

  //   const classes = useStyles();
  const [startDate, setStartDate] = useState(new Date());
  const [returnDate, setReturnDate] = useState(new Date());
  const [tab, setTab] = useState(0);
  console.log("returnDate", returnDate);
  const [makeDisable, setDisable] = useState(true);
  const [counter, setCounter] = useState(1);
  const [luggageShow, setLuggageShow] = useState(false);

  const [luggageInner, setLuggageInner] = useState(0);

  const [handLuggageInner, setHandLuggaeInner] = useState();

  const [finalLugagge, setFinalLugagge] = useState([]);
  const [value, setValue] = useState();
  const [value1, setValue1] = useState();

  const [addressLine1, setAddressLine1] = useState(false);
  const [value2, setValue2] = useState();

  const [addressLine2, setAddressLine2] = useState(false);
  const [value3, setValue3] = useState();

  const [addressLine3, setAddressLine3] = useState(false);
  const [value4, setValue4] = useState();
  const [valueHourly, setValueHourly] = useState();

  const [defaultLocation, setDefaultLocation] = useState();

  const [oneWayHours, setOneWayHours] = useState("01");
  const [oneWayMinutes, setOneWayMinutes] = useState("00");

  const [returnHours, setReturnHours] = useState("01");
  const [returnMinutes, setReturnMinutes] = useState("00");

  const [hourlyDuration, setHourlyDuration] = useState();
  const [hourlyTime, setHourlyTime] = useState();

  console.log("hourlyDuration", hourlyDuration, hourlyTime);
  const [distance1, setDistance1] = useState();
  const [distance2, setDistance2] = useState();
  const [distance3, setDistance3] = useState();
  const [distance4, setDistance4] = useState();
  const [distance5, setDistance5] = useState();
  const [distance6, setDistance6] = useState();
  const [distance7, setDistance7] = useState();

  const [selected, setSelected] = useState("yes");

  const [passengerDetail, setPassengerDetail] = useState(1);
  const [triggerUse1, setTriggerUse1] = useState(false);

  const [finalDistancePrice, setFinalDistancePrice] = useState();

  console.log("valueHourly", valueHourly);

  const handLuggage = [
    {
      luggage: "Hand Luggage (56 x 37 x 25 cm)",
    },
  ];

  const optionsSeconds = [
    { value: "00", label: "00" },
    { value: "05", label: "05" },
    { value: "10", label: "10" },
    { value: "15", label: "15" },
    { value: "20", label: "20" },
    { value: "25", label: "25" },
    { value: "30", label: "30" },
    { value: "35", label: "35" },
    { value: "40", label: "40" },
    { value: "45", label: "45" },
    { value: "50", label: "50" },
    { value: "55", label: "55" },
  ];

  const hourlyHours = [
    { value: "2 Hrs", label: "2 Hrs" },
    { value: "3 Hrs", label: "3 Hrs" },
    { value: "4 Hrs", label: "4 Hrs" },
    { value: "5 Hrs", label: "5 Hrs" },
    { value: "6 Hrs", label: "6 Hrs" },
    { value: "7 Hrs", label: "7 Hrs" },
    { value: "8 Hrs", label: "8 Hrs" },
    { value: "9 Hrs", label: "9 Hrs" },
    { value: "10 Hrs", label: "10 Hrs" },
    { value: "11 Hrs", label: "11 Hrs" },
    { value: "12 Hrs", label: "12 Hrs" },
    { value: "13 Hrs", label: "13 Hrs" },
    { value: "14 Hrs", label: "14 Hrs" },
    { value: "15 Hrs", label: "15 Hrs" },
    { value: "16 Hrs", label: "16 Hrs" },
    { value: "17 Hrs", label: "17 Hrs" },
    { value: "18 Hrs", label: "18 Hrs" },
    { value: "19 Hrs", label: "19 Hrs" },
    { value: "20 Hrs", label: "20 Hrs" },
    { value: "21 Hrs", label: "21 Hrs" },
    { value: "22 Hrs", label: "22 Hrs" },
    { value: "23 Hrs", label: "23 Hrs" },
    { value: "24 Hrs", label: "24 Hrs" },
  ];
  const timeHourly = [
    { value: "00:00", label: "00:00" },
    { value: "00:15", label: "00:15" },
    { value: "00:30", label: "00:30" },
    { value: "00:45", label: "00:45" },
    { value: "01:00", label: "01:00" },
    { value: "01:15", label: "01:15" },
    { value: "01:30", label: "01:30" },
    { value: "01:45", label: "01:45" },
    { value: "02:00", label: "02:00" },
    { value: "02:15", label: "02:15" },
    { value: "02:30", label: "02:30" },
    { value: "02:45", label: "02:45" },
    { value: "03:00", label: "03:00" },
    { value: "03:15", label: "03:15" },
    { value: "03:30", label: "03:30" },
    { value: "03:45", label: "03:45" },
    { value: "04:00", label: "04:00" },
    { value: "04:15", label: "04:15" },
    { value: "04:30", label: "04:30" },
    { value: "04:45", label: "04:45" },
    { value: "05:00", label: "05:00" },
    { value: "05:15", label: "05:15" },
    { value: "05:30", label: "05:30" },
    { value: "05:45", label: "05:45" },
    { value: "05:45", label: "05:45" },
    { value: "06:00", label: "06:00" },
    { value: "06:15", label: "06:15" },
    { value: "06:30", label: "06:30" },
    { value: "06:45", label: "06:45" },
    { value: "07:00", label: "07:00" },
    { value: "07:15", label: "07:15" },
    { value: "07:30", label: "07:30" },
    { value: "07:45", label: "07:45" },
    { value: "08:00", label: "08:00" },
    { value: "08:15", label: "08:15" },
    { value: "08:30", label: "08:30" },
    { value: "08:45", label: "08:45" },
    { value: "09:00", label: "09:00" },
    { value: "09:15", label: "09:15" },
    { value: "09:30", label: "09:30" },
    { value: "09:45", label: "09:45" },
    { value: "10:00", label: "10:00" },
    { value: "10:15", label: "10:15" },
    { value: "10:30", label: "10:30" },
    { value: "10:45", label: "10:45" },
    { value: "11:00", label: "11:00" },
    { value: "11:15", label: "11:15" },
    { value: "11:30", label: "11:30" },
    { value: "11:45", label: "11:45" },
    { value: "12:00", label: "12:00" },
    { value: "12:15", label: "12:15" },
    { value: "12:30", label: "12:30" },
    { value: "12:45", label: "12:45" },
    { value: "13:00", label: "13:00" },
    { value: "13:15", label: "13:15" },
    { value: "13:30", label: "13:30" },
    { value: "13:45", label: "13:45" },
    { value: "14:00", label: "14:00" },
    { value: "14:15", label: "14:15" },
    { value: "14:30", label: "14:30" },
    { value: "14:45", label: "14:45" },
    { value: "15:00", label: "15:00" },
    { value: "15:15", label: "15:15" },
    { value: "15:30", label: "15:30" },
    { value: "15:45", label: "15:45" },
    { value: "16:00", label: "16:00" },
    { value: "16:15", label: "16:15"},
    { value: "16:00", label: "16:00" },
    { value: "16:15", label: "16:15" },
    { value: "16:30", label: "16:30" },
    { value: "16:45", label: "16:45" },
    { value: "17:00", label: "17:00" },
    { value: "17:15", label: "17:15" },
    { value: "17:30", label: "17:30" },
    { value: "17:45", label: "17:45" },
    { value: "18:00", label: "18:00" },
    { value: "18:15", label: "18:15" },
    { value: "18:30", label: "18:30" },
    { value: "18:45", label: "18:45" },
    { value: "19:00", label: "19:00" },
    { value: "19:15", label: "19:15" },
    { value: "19:30", label: "19:30" },
    { value: "19:45", label: "19:45" },
    { value: "20:00", label: "20:00" },
    { value: "20:15", label: "20:15" },
    { value: "20:30", label: "20:30" },
    { value: "20:45", label: "20:45" },
    { value: "21:00", label: "21:00" },
    { value: "21:15", label: "21:15" },
    { value: "21:30", label: "21:30" },
    { value: "21:45", label: "21:45" },
    { value: "22:00", label: "22:00" },
    { value: "22:15", label: "22:15" },
    { value: "22:30", label: "22:30" },
    { value: "22:45", label: "22:45" },
    { value: "23:00", label: "23:00" },
    { value: "23:15", label: "23:15" },

    { value: "23:30", label: "23:30" },
    { value: "23:45", label: "23:45" }
    ];
  
  
  const optionsHours = [
    { value: "00", label: "00" },
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
  ];
  const optionsPassenger = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
  ];

  const oneWaySelected = (e) => {
    setDisable(!makeDisable);
    console.log("checked", e.target.value);
    console.log("checked", e.target);
    console.log("checked", e);
  };

  const plusClicked = () => {
    if (counter < 4) {
      setCounter(counter + 1);
    }

    if (counter === 1) {
      setAddressLine1(!addressLine1);
    }
    if (counter === 2) {
      setAddressLine2(!addressLine2);
    }
    if (counter === 3) {
      setAddressLine3(!addressLine3);
    }

    console.log("counter,,,counterAddress", counter);
  };

  const luggageClicked = () => {
    setLuggageShow(!luggageShow);
  };

  const luggageInnerClicked = () => {
    if (luggageInner != 1) {
      setLuggageInner(1);
    } else {
      setLuggageInner(6);
    }
  };

  const luggageInnerClicked1 = () => {
    if (luggageInner != 2) {
      setLuggageInner(2);
    } else {
      setLuggageInner(6);
    }
  };

  const luggageInnerClicked2 = () => {
    if (luggageInner != 3) {
      setLuggageInner(3);
    } else {
      setLuggageInner(6);
    }
  };

  const luggageInnerClicked3 = () => {
    if (luggageInner != 4) {
      setLuggageInner(4);
    } else {
      setLuggageInner(6);
    }
  };

  const luggageInnerClicked4 = () => {
    if (luggageInner != 5) {
      setLuggageInner(5);
    } else {
      setLuggageInner(6);
    }
  };

  const temp = [];
  const luggageHandClicked = (index, stringValue, luggageExactName) => {
    console.log("loggedHandClicked2");
    const dataObject = {
      quantity: index,
      nameLuggae: stringValue,
      name: luggageExactName,
    };
    console.log("indexStringValue", index, stringValue);
    temp.push(dataObject);

    if (finalLugagge.length === 0) {
      finalLugagge.push(dataObject);
      console.log("loggedHandClicked3");
    } else {
      let tempIndex = undefined;
      console.log("loggedHandClicked4");
      finalLugagge.map((item, index) => {
        if (stringValue === item.nameLuggae) {
          console.log("indexSameValue", index, stringValue, item.nameLuggae);
          tempIndex = index;
        }
      });
      if (tempIndex != undefined) {
        finalLugagge[tempIndex].quantity = index;
      }

      console.log("dataObject", dataObject, finalLugagge, index);
      console.log("loggedHandClicked5");

      if (tempIndex === undefined) {
        finalLugagge.push(dataObject);
        console.log("loggedHandClicked6");
      }
    }
  };

  console.log("finalLugagge", finalLugagge);

  const durationHandler = (e) => {
    setHourlyDuration(e.value);
  };
  const timeHandler = (e) => {
    setHourlyTime(e.value);
  };

  const handLuggageClicked = () => {
    if (handLuggageInner != 1) {
      setHandLuggaeInner(1);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked2 = () => {
    if (handLuggageInner != 2) {
      setHandLuggaeInner(2);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked3 = () => {
    if (handLuggageInner != 3) {
      setHandLuggaeInner(3);
    } else {
      setHandLuggaeInner(5);
    }
  };

  const crossLuggaeClicked = (data, index) => {
    // console.log("dataClickedCross")

    console.log("dataClickedCross", index, finalLugagge);
    data.splice(index, 1);

    setFinalLugagge(data);
  };

  console.log("value2Datat", value2);

  const handLuggageClicked4 = () => {
    if (handLuggageInner != 4) {
      setHandLuggaeInner(4);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked6 = () => {
    if (handLuggageInner != 6) {
      setHandLuggaeInner(6);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked7 = () => {
    if (handLuggageInner != 7) {
      setHandLuggaeInner(7);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked8 = () => {
    if (handLuggageInner != 8) {
      setHandLuggaeInner(8);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked9 = () => {
    if (handLuggageInner != 9) {
      setHandLuggaeInner(9);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked10 = () => {
    if (handLuggageInner != 10) {
      setHandLuggaeInner(10);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked11 = () => {
    if (handLuggageInner != 11) {
      setHandLuggaeInner(11);
    } else {
      setHandLuggaeInner(5);
    }
  };
  const handLuggageClicked12 = () => {
    if (handLuggageInner != 12) {
      setHandLuggaeInner(12);
    } else {
      setHandLuggaeInner(5);
    }
  };

  console.log("value932465", value, value1);

  const crossClicked = () => {
    setAddressLine3(false);
    setCounter(counter - 1);
  };
  const crossClicked2 = () => {
    setAddressLine2(false);
    setCounter(counter - 1);
  };
  const crossClicked3 = () => {
    setAddressLine1(false);
    setCounter(counter - 1);
  };

  async function findLatLong(address) {
    const google = window.google;
    var geocoder = new google.maps.Geocoder();
    console.log("findLatLongAddree", address);

    console.log("geocoder", geocoder);
    var latitude;
    var longitude;
    var newLongitude = await geocoder.geocode(
      { address: address },
      async function (results, status) {
        console.log("esults, status", results, status);
        if (status == google.maps.GeocoderStatus.OK) {
          latitude = await results[0]?.geometry?.location?.lat();
          longitude = await results[0]?.geometry?.location?.lng();
          // alert(latitude);
        }
      }
    );
    // alert(latitude);
    let latlngObj = {
      latitude: latitude,
      longitude: longitude,
    };
    console.log("newLongitude", newLongitude);
    console.log("latitudelatitudeOutSide", latitude, longitude);

    return latlngObj;
  }

  async function calculateDistance(lat1, lng1, lat2, lng2) {
    const origin = new google.maps.LatLng(lat1, lng1);
    const destination = new google.maps.LatLng(lat2, lng2);

    const service = new google.maps.DistanceMatrixService();
    let distanceTemp = await service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
      },
      (response, status) => {
        if (status === "OK") {
          const distanceee = response.rows[0]?.elements[0]?.distance.text;
          console.log(
            `The distance between the two coordinates is: ${distanceee}`
          );
          return distanceee;
        } else {
          console.error(`Error: ${status}`);
        }
      }
    );

    console.log(
      "distanceTemp0",
      distanceTemp?.rows[0]?.elements[0]?.distance?.text
    );

    return distanceTemp?.rows[0]?.elements[0]?.distance?.text;
  }
  let tempCalLuggFinal = 0;
  pricingData?.map((item) => {
    console.log("pricing.pricing", item, pricingData);

    finalLugagge?.map((item2) => {
      console.log("ownPropert", item.name, item2.name, pricingData);
      if (item.name === item2.name) {
        let tempCalLugg = item2.quantity * item.value;

        tempCalLuggFinal = tempCalLugg + tempCalLuggFinal;
        console.log("tempCalLuggFinalInsidde", tempCalLuggFinal);

        // console.log("ownPropert",item?.name,tempCalLugg,nameTemp,item2.nameTemp)
      }
    });
  });

  console.log("tempCalLuggFinal", tempCalLuggFinal);
  console.log("KKKvalue1Clicked", value1, value2, value3, value);
  const calculatePriceClicked1 = () => {
    let newHourlyDuration=hourlyDuration.replace("Hrs", "");
    dispatch(getAllVehicles());
    navigate("/vehicle-booking", {
      state: {
        departureLocation: valueHourly,
        hourlyDuration: newHourlyDuration,
        hourlyTime: hourlyTime,
        startDateHourly: startDate,
        tab: 1,
      },
    });
  };
  const calculatePriceClicked = async () => {
    // const timeDifference = calculateDifferenceInTime();
    //Order of inputs and their lat long main =>11=>33=>44>55>22
    //values order of inputs value,value2,value3,value4,value2

    let lat11;
    let lng11;
    let lat22;
    let lng22;
    let lat33;
    let lng33;
    let lat44;
    let lng44;
    let lat55;
    let lng55;

    if (value) {
      const valuTemp = await findLatLong(value).then((result) => {
        lat11 = result.latitude;
        lng11 = result.longitude;
        console.log("latt11lattt22 result.latitude", result.latitude);
        console.log("latt11lattt22 result.longitude", result.longitude);

        return result;
      });
    }
    if (value1) {
      const valuTemp2 = await findLatLong(value1).then((result) => {
        lat22 = result.latitude;
        lng22 = result.longitude;
      });
    }
    if (value2) {
      const valuTemp3 = await findLatLong(value2).then((result) => {
        lat33 = result.latitude;
        lng33 = result.longitude;
      });
    }
    if (value3) {
      const valuTemp3 = await findLatLong(value3).then((result) => {
        lat44 = result.latitude;
        lng44 = result.longitude;
      });
    }
    if (value4) {
      const valuTemp3 = await findLatLong(value4).then((result) => {
        lat55 = result.latitude;
        lng55 = result.longitude;
      });
    }

    if (lat11 && lng11 && lat22 && lng22) {
      let newClickedDistance1 = await calculateDistance(
        lat11,
        lng11,
        lat22,
        lng22
      );

      setDistance1(newClickedDistance1);
    }

    if (lat11 && lng11 && lat33 && lng33) {
      let newClickedDistance2 = await calculateDistance(
        lat11,
        lng11,
        lat33,
        lng33
      );

      setDistance2(newClickedDistance2);
    }

    if (lat33 && lng33 && lat44 && lng44) {
      let newClickedDistance3 = await calculateDistance(
        lat33,
        lng33,
        lat44,
        lng44
      );

      setDistance3(newClickedDistance3);
    }

    if (lat44 && lng44 && lat55 && lng55) {
      let newClickedDistance4 = await calculateDistance(
        lat44,
        lng44,
        lat55,
        lng55
      );
      setDistance4(newClickedDistance4);
    }

    if (lat55 && lng55 && lat22 && lng22) {
      let newClickedDistance5 = await calculateDistance(
        lat55,
        lng55,
        lat22,
        lng22
      );

      setDistance5(newClickedDistance5);
    }

    if (lat33 && lng33 && lat22 && lng22) {
      let newClickedDistance6 = await calculateDistance(
        lat33,
        lng33,
        lat22,
        lng22
      );

      console.log(
        "lat33,lng33,lat22,lng22",
        lat33,
        lng33,
        lat22,
        lng22,
        newClickedDistance6
      );

      setDistance6(newClickedDistance6);
    }
    if (lat44 && lng44 && lat22 && lng22) {
      let newClickedDistance7 = await calculateDistance(
        lat44,
        lng44,
        lat22,
        lng22
      );

      console.log(
        "lat44,lng44,lat22,lng22",
        lat44,
        lng44,
        lat22,
        lng22,
        newClickedDistance7
      );

      setDistance7(newClickedDistance7);
    }

    dispatch(getAllVehicles());
console.log("BlackfinalDistancePrice",finalDistancePrice)
    if (finalDistancePrice) {

      let newDistance = finalDistancePrice;
      if(newDistance)
      {

        newDistance = newDistance?.toString().replace(",", "");
      }
      navigate("/vehicle-booking", {
        state: {
          
          totalDistance: Number(newDistance),
          departureLocation: value,
          via1: value2,
          via2: value3,
          via3: value3,
          arrivalLocation: value1,
          passenger: passengerDetail,
          finalLugagge: finalLugagge,
          makeDisable: makeDisable,
          tab: 0,
        },
      });
    }
  };

  console.log(
    "navigateData",
    value,
    value2,
    value3,
    value4,
    value1,
    startDate,
    returnDate
  );

  console.log("pricingDataNNMMM", pricingData);
  console.log("pricingDataNNMMMpricingDataNNMMM", distance1,distance2,distance3,distance4,distance5,distance6,distance7,finalDistancePrice);
  // console.log("blackdistance1 out",distance1,distance2)
  useEffect(() => {
    //distance1 is between first default 2 inputs
    //distance2 is first default and first created field
    //distance3 is first created and second created field
    //distance4 is second created and third created field
    //distance5 is third created and second default field
    //distance6 is first created and second default field
    //distance7 is second created and second default field

    if (
      distance1 &&
      !distance2 &&
      !distance3 &&
      !distance4 &&
      !distance5 &&
      !distance6 &&
      !distance7
    ) {
      var newValueNumber = distance1.replace(",", "").replace("km", "");
      console.log("here 1rd")

   
      setFinalDistancePrice(newValueNumber);
    }

    if (
      distance1 &&
      distance2 &&
      !distance3 &&
      !distance4 &&
      !distance5 &&
      distance6 &&
      !distance7
    ) {
      var newValueNumber1 =distance2.replace(",", "").replace("km", "");
      var newValueNumber2 = distance6.replace(",", "").replace("km", "");
console.log("here 2rd")
      var newValueNumberAdded =
        Number(newValueNumber1) + Number(newValueNumber2);

      setFinalDistancePrice(newValueNumberAdded);
    }
    if (
      distance1 &&
      distance2 &&
      distance3 &&
      !distance4 &&
      !distance5 &&
      distance6 &&
      distance7
    ) {
      var newValueNumber1 = distance2.replace(",", "").replace("km", "");
      var newValueNumber2 = distance3.replace(",", "").replace("km", "")
      var newValueNumber3 = distance7.replace(",", "").replace("km", "")
      console.log("here 3rd")
      var newValueNumberAdded =
        Number(newValueNumber1) +
        Number(newValueNumber2) +
        Number(newValueNumber3);

    
      console.log("blackdistance1",distance1,distance2,newValueNumberAdded,newValueNumber1,newValueNumber2,newValueNumber3)

  
      setFinalDistancePrice(newValueNumberAdded);
    }
    if (
      distance1 &&
      distance2 &&
      distance3 &&
      distance4 &&
      distance5 &&
      distance6 &&
      distance7
    ) {
      var newValueNumber11 = distance2.replace(",", "").replace("km", "");
      var newValueNumber22 = distance3.replace(",", "").replace("km", "");

      var newValueNumber44 =distance4.replace(",", "").replace("km", "");
      var newValueNumber55 = distance5.replace(",", "").replace("km", "");
      console.log("here 4rd")
      var newValueNumberAdded9 =
        Number(newValueNumber11) +
        Number(newValueNumber22) +
        Number(newValueNumber44) +
        Number(newValueNumber55);

      console.log(
        "lastIffDistanceCal",
        newValueNumber11,
        newValueNumber22,
        newValueNumber22,
        newValueNumber44,
        newValueNumber55,
        newValueNumberAdded9
      );
      console.log("pricingDataNNMMMpricingDataNNMMM last..inside", distance2,distance3,distance4,distance5,newValueNumberAdded9,finalDistancePrice);

      setFinalDistancePrice(newValueNumberAdded9);
    }
  }, [
    distance1,
    distance2,
    distance6,
    distance3,
    distance7,
    distance4,
    distance5,
  ]);

  console.log(
    "distance11111",
    distance1,
    finalDistancePrice,
    distance2,
    distance3,
    distance4,
    distance5,
    distance6,
    distance7
  );

  function distance(lat1, lon1, lat2, lon2, unit) {
    console.log("funcLatLong", lat1, lon1, lat2, lon2);
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "M") {
      dist = dist * 0.8684;
    }
    return dist;
  }

  useEffect(() => {
    setValue(defaultLocation);
  }, [defaultLocation]);

  useEffect(() => {
    dispatch(getPricing());
  }, []);

  const hourChangeHandler = (e) => {
    setOneWayHours(e.value);
  };

  const secondChangeHandler = (e) => {
    setOneWayMinutes(e.value);
  };
  const hourRetChangeHandler = (e) => {
    setReturnHours(e.value);
  };

  const secondRetChangeHandler = (e) => {
    setReturnMinutes(e.value);
  };

  console.log("oneWayHours", oneWayHours, oneWayMinutes);

  function calculateDifferenceInTime() {
    var dateToOneWay = moment(startDate).format("YYYY-MM-DD");
    var dateToReturn = moment(returnDate).format("YYYY-MM-DD");

    let concatdatasd = dateToOneWay + "" + "T" + "" + oneWayHours;
    let concatdatasdReturn = dateToReturn + "" + "T" + "" + returnHours;

    const date1 = new Date(concatdatasd);
    const date2 = new Date(concatdatasdReturn);
    const diffInTime = date2.getTime() - date1.getTime();
    const diffInMinutes = diffInTime / (1000 * 60);

    return diffInMinutes;
  }

  const passengerHandleChange = (e) => {
    setPassengerDetail(e.value);
  };

  
  if (finalDistancePrice && value1 && value) {
    let departureTime1 = oneWayHours + ":" + oneWayMinutes;
    
    let arrivalTime1 = returnHours + ":" + returnMinutes;
    let newDistance = finalDistancePrice;
    if(newDistance)
    {

      newDistance = newDistance?.toString().replace(",", "");
    }
    
    console.log("finalDistancePricepassengerHandleChange", finalDistancePrice,newDistance);
    navigate("/vehicle-booking", {
      state: {
     
        totalDistance: Number(newDistance),
        departureLocation: value,
        via1: value2,
        via2: value3,
        via3: value4,
        arrivalLocation: value1,
        passenger: passengerDetail,
        departureDate: startDate,
        departureTime: departureTime1,
        returnDate: returnDate,
        arrivalTime: arrivalTime1,
        finalLugagge: finalLugagge,
        makeDisable: makeDisable,
        tab: 0,
      },
    });
  }

  const handleChange = (event) => {
    console.log(event.target.value);
    setSelected(event.target.value);
    setDisable(!makeDisable);
  };

  const tabClicked = () => {
    setTab(0);
  };
  const tabClicked1 = () => {
    setTab(1);
  };
  console.log("makeDisable", makeDisable);

  const dateHandler=(date)=>{
    // onChange={(date: Date) => setStartDate(date)}
    
    // const newDate = moment(date).format("DD-MM-YYYY");
    // const startDate1 = new Date(newDate);
    
    // console.log("dateHandler",startDate1)
            setStartDate(date)



  }
  return (
    <>
      <div className="mainSearchBook">
        {/* <p className="getQuoteTxt"> Get Quick Quote</p> */}

        <div className="topTabCalPrice">
          <div
            className={tab === 0 ? "bookNowTxt1" : "bookNowTxt"}
            onClick={tabClicked}
          >
            Book Now
          </div>
          <div
            className={tab === 1 ? "bookNowTxt1" : "bookNowTxt"}
            onClick={tabClicked1}
          >
            Hourly
          </div>
        </div>

        {tab === 0 && (
          <div className="topBottomDataTab">
            <div>
              <GoogleMapAuto
                addressData={addressData}
                setValue={setValue}
                placeholder="From: Enter pickup postcode, venue or place"
              />
            </div>
            <div className="secondRowQuickQu">
              <div className="topInnerViaPlus" onClick={plusClicked}>
                <div>
                  <FaPlusCircle className="plusIconSB" />
                </div>
                <div className="viaTxt">Via</div>
              </div>
              <div>
                <TbArrowsDownUp className="plusIconSB" />
              </div>
            </div>

            {addressLine1 && (
              <div
                className="
      
      secondLocationMapTop1"
              >
                <GoogleMapAuto
                  addressData={addressData}
                  setValue={setValue2}
                  placeholder="Enter via address 1"
                />

                {addressLine2 === false && (
                  <RxCrossCircled
                    className="crossIconCircle"
                    onClick={crossClicked3}
                  />
                )}
              </div>
            )}

            {addressLine2 && (
              <div className="secondLocationMapTop secondLocationMapTop1">
                <GoogleMapAuto
                  addressData={addressData}
                  setValue={setValue3}
                  placeholder="Enter via address 2"
                />

                {addressLine3 == false && (
                  <RxCrossCircled
                    className="crossIconCircle"
                    onClick={crossClicked2}
                  />
                )}
              </div>
            )}
            {addressLine3 && (
              <div className="secondLocationMapTop secondLocationMapTop1">
                <GoogleMapAuto
                  addressData={addressData}
                  setValue={setValue4}
                  placeholder="Enter via address 3"
                />
                {addressLine3 && (
                  <RxCrossCircled
                    onClick={crossClicked}
                    className="crossIconCircle"
                  />
                )}
              </div>
            )}
            <div className="secondLocationMapTop">
              <GoogleMapAuto
                addressData={addressData}
                setValue={setValue1}
                placeholder="To: Enter destination postcode, venue or place"
              />
            </div>

            <div className="lineSB"></div>

            <div className="thirdRowQuickQu  ">
              <div className="topInputWayTxt">
                {/* <input
              type="radio"
              id="radioBtnSB"
              name="oneway"
             
              onChange={(e)=>oneWaySelected(e)}
            /> */}
                <input
                  type="radio"
                  id="yes"
                  name="choose"
                  value="yes"
                  className="radioInputSB"
                  checked={selected === "yes"}
                  onChange={handleChange}
                />
                <p className="oneWayTxt">One way</p>
              </div>
              <div className="topSecondRowSecHalf">
                <DatePicker
                  className="datePickerSB"
                  selected={startDate}
                  dateFormat="dd-MM-yyyy" // <-- Change the date format here

                  onChange={(date: Date) => dateHandler(date)}
                />
                <Select
                  options={timeHourly}
                  onChange={hourChangeHandler}
                  placeholder="00:00"
                  className="selectOpSB"
                />
              </div>
            </div>
            <div className="thirdRowQuickQu fourthRowQuickQu">
              <div className="topInputWayTxt">
                {/* <input
              type="radio"
              id="radioBtnSB"
              onChange={(e)=>oneWaySelected(e)}
              name="oneway"
            /> */}
                <input
                  type="radio"
                  id="no"
                  className="radioInputSB"
                  name="choose"
                  value="no"
                  onChange={handleChange}
                  checked={selected === "no"}
                />
                <p className="oneWayTxt">Return</p>
              </div>
              <div className="topSecondRowSecHalf">
                <DatePicker
                  className="datePickerSB"
                  selected={returnDate}
                  disabled={makeDisable ? true : false}
                  onChange={(date: Date) => setReturnDate(date)}
                  dateFormat="dd-MM-yyyy" // <-- Change the date format here

                />
                <Select
                  options={timeHourly}
                  isDisabled={makeDisable ? true : false}
                  placeholder="00:00"
                  className="selectOpSB"
                  onChange={hourRetChangeHandler}
                />
              </div>
            </div>
            <div className="lineSB"></div>
            {/* <div className="topPassengerLuggage">
          <div className="topPassSelect">
            <div>Passengers</div>
            <Select
              options={optionsPassenger}
              placeholder="01"
              className="passengerSelect"
              onChange={passengerHandleChange}
            />
          </div>
          <div className="topLuggageSelect">
            <div>Luggage</div>
            <div className="luggageSelect" onClick={luggageClicked}>
              Luggage*
            </div>

            {luggageShow && (
              <div className="mainTopLuggage">
                <div className="topPlusLuggage" onClick={luggageInnerClicked}>
                  <HiPlusSm />
                  <div className="txtLuggage">Luggage</div>
                </div>
                {luggageInner === 1 && (
                  <div className="mainInneruggageRowTop">
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">
                          Hand Luggage(56 x 37
                        </div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 1 && (
                      <div
                        className="topContainerNumberSB"
                        onClick={handLuggageClicked}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight />

                          <span> Hand Luggage(56 x 37 x 25 cm)</span>
                        </div>
                        {Array.from(Array(21)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "X Hand Luggage (56 x 37 x 25 cm)",
                                  "handLuggage"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <div className="mainInneruggageRow">
                      <div
                        className="topArrowTextSB"
                        onClick={handLuggageClicked2}
                      >
                        <BsArrowRight />
                        <div className="insideLuggageTxt">
                          Suitcase(78 x 50 x 32 c
                        </div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 2 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSB1"
                        onClick={handLuggageClicked2}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight />

                          <span> Suitcase (78 x 50 x 32 cm)</span>
                        </div>
                        {Array.from(Array(12)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Suitcase (78 x 50 x 32 cm)",
                                  "suitcase"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="mainInneruggageRow">
                      <div
                        className="topArrowTextSB"
                        onClick={handLuggageClicked3}
                      >
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Backpack</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 3 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSB2 "
                        onClick={handLuggageClicked3}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="backArrow" />

                          <span>Backpack</span>
                        </div>
                        {Array.from(Array(20)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Backpack",
                                  "backPack"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="mainInneruggageRow">
                      <div
                        className="topArrowTextSB"
                        onClick={handLuggageClicked4}
                      >
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Rucksack</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 4 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSB3 "
                        onClick={handLuggageClicked4}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="backArrow" />

                          <span>Backpack</span>
                        </div>
                        {Array.from(Array(14)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Rucksack",
                                  "ruckSack"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                <div className="topPlusLuggage" onClick={luggageInnerClicked1}>
                  <HiPlusSm />
                  <div className="txtLuggage">Boxes</div>
                </div>
                {luggageInner === 2 && (
                  <div className="mainInneruggageRowTop">
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked6}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">
                          Large box (20 x 20 x 20 i
                        </div>
                      </div>
                      <IoIosArrowDown />
                    </div>

                    {handLuggageInner === 6 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBAuto"
                        onClick={handLuggageClicked6}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Large box (20 x 20 x 20 inches)</span>
                        </div>
                        {Array.from(Array(8)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Boxes",
                                  "largBox"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}

                <div className="topPlusLuggage" onClick={luggageInnerClicked2}>
                  <HiPlusSm />
                  <div className="txtLuggage">Child items</div>
                </div>
                {luggageInner === 3 && (
                  <div className="mainInneruggageRowTop">
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked7}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Child's pram</div>
                      </div>
                      <IoIosArrowDown />
                    </div>

                    {handLuggageInner === 7 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBAuto"
                        onClick={handLuggageClicked7}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Child's pram</span>
                        </div>
                        {Array.from(Array(8)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Child's pram",
                                  "childItem"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}

                <div className="topPlusLuggage" onClick={luggageInnerClicked3}>
                  <HiPlusSm />
                  <div className="txtLuggage">Folded wheelchair</div>
                </div>
                {luggageInner === 4 && (
                  <div className="mainInneruggageRowTop">
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked8}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">
                          Folded wheelchair
                        </div>
                      </div>
                      <IoIosArrowDown />
                    </div>

                    {handLuggageInner === 8 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBAuto"
                        onClick={handLuggageClicked8}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Folded wheelchair</span>
                        </div>
                        {Array.from(Array(4)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Folded wheelchair",
                                  "wheelchair"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                <div className="topPlusLuggage" onClick={luggageInnerClicked4}>
                  <HiPlusSm />
                  <div className="txtLuggage">Outdoor items</div>
                </div>
                {luggageInner === 5 && (
                  <div className="mainInneruggageRowTop">
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked9}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Pair of skies</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 9 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBAuto"
                        onClick={handLuggageClicked9}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Pair of skies</span>
                        </div>
                        {Array.from(Array(3)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Pair of skies",
                                  "pairSkies"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="mainInneruggageRow">
                      <div
                        className="topArrowTextSB"
                        onClick={handLuggageClicked10}
                      >
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Snowboard</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 10 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBSnow topContainerNumberSBAuto"
                        onClick={handLuggageClicked10}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Snowboard</span>
                        </div>
                        {Array.from(Array(4)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Snowboard",
                                  "snowboard"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked11}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Bike</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 11 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBBike topContainerNumberSBAuto"
                        onClick={handLuggageClicked11}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Bike</span>
                        </div>
                        {Array.from(Array(2)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(index + 1, "Bike", "bike")
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div
                      className="mainInneruggageRow"
                      onClick={handLuggageClicked12}
                    >
                      <div className="topArrowTextSB">
                        <BsArrowRight />
                        <div className="insideLuggageTxt">Golf bag</div>
                      </div>
                      <IoIosArrowDown />
                    </div>
                    {handLuggageInner === 12 && (
                      <div
                        className="topContainerNumberSB topContainerNumberSBBike topContainerNumberSBAuto"
                        onClick={handLuggageClicked12}
                      >
                        <div className="firstNameHL">
                          <BsArrowRight className="rightArrow" />

                          <span>Golf bag</span>
                        </div>
                        {Array.from(Array(4)).map((c, index) => {
                          return (
                            <div
                              className="luggageFirstRow"
                              onClick={() =>
                                luggageHandClicked(
                                  index + 1,
                                  "Golf bag",
                                  "golfBag"
                                )
                              }
                            >
                              {index + 1}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div> */}

            {/* {finalLugagge?.map((item, index) => (
          <div className="mainFinalLuggage">
            <div className="mainFinalLuggageLeft">
              <div>{item.quantity}</div>
              <div>{item.nameLuggae}</div>
            </div>

            <ImCross
              className="crossLuggage"
              onClick={() => crossLuggaeClicked([...finalLugagge], index)}
            />
          </div>
        ))}
       */}

            <div
              className="btnCalculatePrice"
              onClick={() => calculatePriceClicked()}
            >
              Search
              <FaArrowRight />
            </div>
          </div>
        )}

        {tab === 1 && (
          <div className="topBottomDataTab">
            <div>
              <GoogleMapAuto
                addressData={addressData}
                setValue={setValueHourly}
                placeholder="From: Enter pickup postcode, venue or place"
              />
            </div>

            <div className="lineSB"></div>

            <div className="thirdRowQuickQu">
              <div className="topSecondRowSecHalf topSecondRowSecHalf1">
                <div className="topHourlyPic">
                  <div className="txtHourly">Duration</div>
                  <Select
                    options={hourlyHours}
                    onChange={durationHandler}
                    placeholder="2 Hrs"
                    // defaultInputValue="01"
                    // className="selectOpSB"
                  />
                </div>
                <div className="topHourlyPic">
                  <div className="txtHourly">Pick Up Date</div>
                  <DatePicker
                    className="datePickerSB"
                    selected={startDate}
                    onChange={(date: Date) => dateHandler(date)}
                    dateFormat="dd-MM-yyyy" // <-- Change the date format here

                  />
                </div>
                <div className="topHourlyPic">
                  <div className="txtHourly">TIME</div>
                  <Select
                    options={timeHourly}
                    onChange={timeHandler}
                    placeholder="00:00"
                    // defaultInputValue="01"
                    className="selectOpSB"
                  />
                </div>
              </div>
            </div>

            <div className="lineSB"></div>

            <div
              className="btnCalculatePrice"
              onClick={() => calculatePriceClicked1()}
            >
              Search
              <FaArrowRight />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchBooking;
